/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".search[_ngcontent-%COMP%]{margin-bottom:0!important}.search__submit[_ngcontent-%COMP%]{width:100%;text-align:center}.search__submit[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{min-width:150px}"];
export { styles as styles };
